export const NON_LIFE_INSURANCE_TYPES = [
	"property",
	"household",
	"liability",
	"vehicle",
	"travel",
	"business",
	"accident",
] as const;

export type NonLifeInsuranceType = (typeof NON_LIFE_INSURANCE_TYPES)[number];
